import queryString from 'query-string';


export default function popQueryString(url, paramsToRemove) {
  const [baseUrl, currentParamsString] = url.split('?', 2);
  let currentParams = queryString.parse(currentParamsString);
  paramsToRemove.map((parameter) => {
    delete currentParams[parameter];
  });
  const finalParamsString = queryString.stringify({ ...currentParams }, { encode: false });
  return `${baseUrl}?${finalParamsString}`;
};
